export default "__VITE_ASSET__DblYWueJ__"